module.exports = "https://coinrabbit.io/_next/static/images/privacy_text_mobile-icon-27297af5e84bb37832a5d3b9096731d5.png";